<template>
  <v-dialog
    v-model="showDialogData"
    no-click-animation
    persistent
    width="500"
    :transition="false"
  >
    <v-card>
      <v-card-title>
        {{ $t('globals.maintenanceMode') }}
      </v-card-title>
      <v-card-text>
        {{ $t('globals.maintenanceModeHint') }}
      </v-card-text>
      <v-divider />
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'MaintenanceMode',
   props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  data: () => ({
  }),
  computed: {
    showDialogData: {
      get() {
        return this.showDialog;
      },
      set(value) {
        this.$emit('update:showDialog', value);
      }
    }
  },
  methods: {
  }

}
</script>

<style lang="scss" scoped>
</style>
